<template>
  <el-submenu :index="route.path" v-if="!route.hidden" class="submenu">
    <template slot="title">
      <span>{{$t(route.meta.title)}}</span>
      <!-- <div @click="menuTab(route)">{{$t(route.meta.title)}}</div> -->
    </template>
    <template v-for="(c,key) in route.children">
      <el-menu-item class="sub-menu-item" :index="c.path" :key="key" v-if="!c.hidden" @click="menuTab(c)">
        <!-- <i v-if="c.meta.iconClass && c.meta.iconClass !== ''" :class="c.meta.iconClass"></i> -->
        <span slot="title">{{$t(c.meta.title)}}</span>
        <i v-if="$route.path === c.path" class="el-icon-arrow-right right-arrow"></i>
      </el-menu-item>
    </template>
    <!-- <el-menu-item-group v-if="route.children"></el-menu-item-group> -->
  </el-submenu>
</template>
<script>
import { mapMutations } from "vuex";
export default {
  name: "submenu",
  props: ["route"],
  computed: {
    isMobile() {
      return this.$store.state.app.isMobileMode;
    }
  },
  methods: {
    ...mapMutations({
      CloseMobileSideBar: "app/CloseMobileSideBar",
      CloseToolBar: "app/CloseToolBar"
    }),
    menuTab(route) {
      if (this.isMobile) {
        this.CloseMobileSideBar();
        this.CloseToolBar();
      }
      try {
        this.$router.push({ path: route.path });
      } catch (error) {}
    }
  }
};
</script>
<style lang="scss" scoped>
.submenu{
  ::v-deep{
    .el-menu{
      padding-left: 20px;
    }
  }
}
</style>

